module.exports = function getElasticFacets(
	response,
	typeDefinitions,
	hideFilterByType = false
) {
	let facets = [];
	if (response.facets) {
		for (const [id, facet] of Object.entries(response.facets)) {
			if (facet[0] && Array.isArray(facet[0].data) && facet[0].data.length > 0) {
				if (!hideFilterByType || id !== "type") {
					let option = {
						id,
						title: id,
						items: facet[0].data.map(({ value, count }) => {
							const typedef =
								value &&
								typeof value === "string" &&
								value.includes("--") &&
								typeDefinitions
									? typeDefinitions.find((td) => td.bundle === value.split("--")[1])
									: null;
							const title = typedef ? typedef.name : value;
							return {
								id: value,
								title,
								value,
								count,
							};
						}),
					};
					facets.push(option);
				}
			}
		}
	}
	return facets;
};
